/* @pareto-engineering/generator-front 1.1.1-alpha.1 */
import * as React from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import './styles.scss'

const baseClassName = styleNames.base

const componentClassName = 'blur-overlay'

const BlurOverlay = ({
  id,
  className:userClassName,
  style,
  children,
  blur,
}) => (
  <div
    id={id}
    className={[
      baseClassName,
      componentClassName,
      userClassName,
      blur && styleNames.modifierActive,
    ]
      .filter((e) => e)
      .join(' ')}
    style={style}
  >
    { children }
  </div>
)

BlurOverlay.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   *  The children JSX
   */
  children:PropTypes.node,

  /**
   *  Boolean to toggle blur effect
   */
  blur:PropTypes.bool,
}

BlurOverlay.defaultProps = {
  blur:true,
  // someProp:false
}

export default BlurOverlay
